import { useNavigate } from 'react-router-dom';
import './styles/Lesson.scss'

export default function Lesson({ number, title, motto, locked = false, completed = false }: any) {
    const navigate = useNavigate();

    return (
        <div
            onClick={() => { if (!locked) { sessionStorage.setItem('scrollPosition', window.scrollY.toString()); navigate(number); } }}
            className={"lesson" + (locked ? " locked" : "") + (completed ? " completed" : "")}
        >
            <div className="num">{number}</div>

            <div className="body">
                <h1>{title}</h1>
                {motto && <h2>„{motto}"</h2>}
            </div>

            {completed && <img className="completed" src="/images/components/completed.png" alt="" />}
        </div>
    );
}
